import { render, staticRenderFns } from "./aftersale_mobie.vue?vue&type=template&id=7b24ddd8&"
import script from "./aftersale_mobie.vue?vue&type=script&lang=js&"
export * from "./aftersale_mobie.vue?vue&type=script&lang=js&"
import style0 from "./aftersale_mobie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports